<template>
  <div>
    <loader class="loader" :size="'8px'" v-if="costReportBusy"></loader>
    <div v-if="!Array.isArray(costReport)">
      <div class="report-date">{{ reportTime }}(30 Days)</div>
      <div class="report-wrapper">
        <date-picker
          lang="en"
          placeholder="Select Date"
          :disabled-date="notAfterTomorrow"
          v-model="reportDate"
          input-class="form-control"
          @input="getReportByDate"
        ></date-picker>
      </div>
      <div class="cost-tables">
        <div
          v-for="costs in ['campaigns_cost', 'keywords_cost', 'locations_cost']"
          v-bind:key="costs"
        >
          <span class="table-header">{{ costs.split("_")[0] }}</span>
          <div class="cost-table">
            <table :id="costs">
              <tr>
                <td></td>
                <td>{{ formatCurrency(totalCosts[costs]["Application"]) }}</td>
                <td>{{ formatCurrency(totalCosts[costs]["Display"]) }}</td>
                <td>{{ formatCurrency(totalCosts[costs]["Search"]) }}</td>
              </tr>
              <tr>
                <th>
                  Name
                  <button
                    v-if="costs !== 'keywords_cost'"
                    v-on:click="applySorting(0, 0, costs)"
                    class="btn btn-default btn-sm override"
                  >
                    <span
                      class="fa"
                      :class="{
                        'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                        'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                      }"
                    ></span>
                  </button>
                </th>
                <th>
                  Application(&#8362;)
                  <button
                    v-if="costs !== 'keywords_cost'"
                    v-on:click="applySorting(1, 1, costs)"
                    class="btn btn-default btn-sm override"
                  >
                    <span
                      class="fa"
                      :class="{
                        'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                        'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                      }"
                    ></span>
                  </button>
                </th>
                <th>
                  Display(&#8362;)
                  <button
                    v-if="costs !== 'keywords_cost'"
                    v-on:click="applySorting(1, 2, costs)"
                    class="btn btn-default btn-sm override"
                  >
                    <span
                      class="fa"
                      :class="{
                        'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                        'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                      }"
                    ></span>
                  </button>
                </th>
                <th>
                  Search(&#8362;)
                  <button
                    v-if="costs !== 'keywords_cost'"
                    v-on:click="applySorting(1, 3, costs)"
                    class="btn btn-default btn-sm override"
                  >
                    <span
                      class="fa"
                      :class="{
                        'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                        'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                      }"
                    ></span>
                  </button>
                </th>
              </tr>
              <tr
                v-if="indicateNonAscii(key)"
                v-for="(value, key) in costReport[costs]"
                v-bind:key="value"
              >
                <td>{{ key | truncate(30) }}</td>
                <td>{{ formatCurrency(value.Application) }}</td>
                <td>{{ formatCurrency(value.Display) }}</td>
                <td>{{ formatCurrency(value.Search) }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="devices-table">
        <table id="devices_cost">
          <tr>
            <th>
              Device
              <button
                v-on:click="applySorting(1, 1, 'devices_cost')"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Clicks
              <button
                v-on:click="applySorting(1, 2, 'devices_cost')"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Cost/conv.(&#8362;)
              <button
                v-on:click="applySorting(1, 2, 'devices_cost')"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th>
              Impressions
              <button
                v-on:click="applySorting(1, 3, 'devices_cost')"
                class="btn btn-default btn-sm override"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                    'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                  }"
                ></span>
              </button>
            </th>
          </tr>
          <tr
            v-for="(value, key) in costReport['devices_cost']"
            v-bind:key="value"
          >
            <td>{{ key }}</td>
            <td>{{ value["Clicks"] }}</td>
            <td>{{ formatCurrency(value["Cost / conv."]) }}</td>
            <td>{{ value["Impressions"] }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import apiClientCreator from "../../../../helpers/api/request";
import DatePicker from "vue2-datepicker";
import {mapGetters, mapState} from "vuex";
import moment from "moment";

export default {
  name: "CostStats.container",
  components: { DatePicker },
  data() {
    return {
      costReport: [],
      totalCosts: [],
      reportDate: null,
      sortOrder: {
        0: "desc",
        1: "desc"
      },
      costReportBusy: false,
      reportTime: null
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.fetchCostsReport();
  },
  methods: {
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    /**
     * Fetches the cost report
     */
    async fetchCostsReport() {
      if (
        !this.costReportBusy &&
        this.checkPermissions(this.auth, [1, 2, 3, 12])
      ) {
        try {
          this.costReportBusy = true;
          const res = await apiClientCreator(`reports/cost/report`).get("");
          this.costReport = res.data["report"];
          this.totalCosts = res.data["stats"];
          this.reportTime = res.data["date"];
          this.reportDate = this.reportTime;
          this.costReportBusy = false;
        } catch (e) {}
      }
    },
    /**
     *  Fetches the cost report by a given date
     */
    async getReportByDate() {
      if (this.checkPermissions(this.auth, [1, 2, 3])) {
        try {
          const res = await apiClientCreator(
            `reports/cost/report_by_date/${moment(this.reportDate).format(
              "YYYY-MM-DD"
            )}`
          ).get("");
          this.costReport = res.data["report"];
          this.totalCosts = res.data["stats"];
          this.reportTime = res.data["date"];
        } catch (e) {}
      }
    },
    applySorting(typeSort, tableColumn, tableId) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById(tableId);
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 2; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    },
    indicateNonAscii(string) {
      return ![...string].some(char => char.charCodeAt(0) > 127);
    },
    formatCurrency(num) {
      if (num === undefined) {
        return 0;
      }
      return num === 0 ? 0 : ((num * 3.37) / 100).toFixed(2);
    },
    notAfterTomorrow(date) {
      return date > moment();
    }
  }
};
</script>

<style scoped>
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em;
}
th {
  background: white;
  position: sticky;
  top: 0;
}
.table-header {
  display: flex;
  justify-content: center;
  font-weight: bold;
}
.cost-tables,
.devices-table {
  padding: 1em 0;
  display: flex;
  justify-content: space-evenly;
}
.cost-table {
  overflow-y: scroll;
  height: 550px;
}
.report-date {
  display: flex;
  justify-content: center;
  padding: 2em 0;
  font-weight: bold;
  font-size: 0.8vw;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
}
.btn-sm:active {
  border: none;
  outline: none;
  background: #e0e0e0;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.report-wrapper {
  display: flex;
  justify-content: center;
}
</style>
